import React, { useEffect } from 'react';

const PhotoModal = ({ isOpen, imageSrc, imageAlt, onClose }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="photo-modal" onClick={onClose}>
      <span className="photo-modal-close" onClick={onClose}>
        ×
      </span>
      <img src={imageSrc} alt={imageAlt} onClick={(e) => e.stopPropagation()} />
    </div>
  );
};

export default PhotoModal;
